import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router";

import styled from "@emotion/styled";

import VtpassBalanceBanner from "../../components/Banner/VtpassBalanceBanner";
import CommandMenu from "../../components/CommandMenu/CommandMenu";
import { InboxProvider } from "../../context/InboxContext";
import MobileNav from "./sideNav/MobileNav";
import Nav from "./sideNav/Nav";

const DashboardLayoutOutlet = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { pathname } = useLocation();

  useEffect(() => {
    containerRef.current?.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <InboxProvider>
      <Container ref={containerRef}>
        <Nav />
        <MobileNav />
        <CommandMenu />
        <Section>
          <MainContent>
            <VtpassBalanceBanner />
            <Outlet />
          </MainContent>
        </Section>
      </Container>
    </InboxProvider>
  );
};

export default DashboardLayoutOutlet;

const Container = styled.div`
  display: flex;
  height: 100vh;
  overflow: auto;
  width: 100%;
  background-color: var(--ground);
`;

const Section = styled.section`
  flex: 1;
  min-width: 0;
  height: fit-content;

  @media (max-width: 884px) {
    padding-top: 56px;
  }
`;

const MainContent = styled.main`
  height: 100%;
  padding-bottom: 96px;
  width: 100%;
`;
